// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__V8_WG","default":"Textarea_default__JrQnL","fullWidth":"Textarea_fullWidth__Kt31D","noResize":"Textarea_noResize__kOOlz"};